var baseApiUrl = process.env.REACT_APP_MANAGE_ISSUE_BASE_URL;
const baseurl = baseApiUrl + "api";
const baseurlfoRsourceurlwithnorecords = baseurl + "/v1/dashboard";
export const BASE_NO_RECORDS_URL = baseurlfoRsourceurlwithnorecords;
export const SOURCE_URL_NO_RECORDS_URL =
  baseurlfoRsourceurlwithnorecords + "/getsourceurlwithnorecordsdetailview";
export const SOURCE_URL_NO_RECORDS_EXPORT_URL =
  baseurlfoRsourceurlwithnorecords + "/exportsourceurlwithnorecordsdetailview";
